import React, { Component } from "react";
import {Icon, Popup} from "semantic-ui-react";
import moment from 'moment';


class MessageDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data :{}
        }
    }




    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    makeBold = (item, keyword) => {
        var re = new RegExp(keyword, 'g')
        return (
            item.replace(re, '<i>'+keyword+ '</i>')
        )
    }

    static getStatusColor(status) {
        let color = '#CA443B'
          if (status === 'CBSA_ACCEPTED'||  status === 'CBSA_FUNCTIONAL_ACKNOWLEDGED_ACCEPTED' || status.includes('RNS')) {
            color = '#008800'
          }  else if (status === 'CBSA_REJECTED' ||status === 'CBSA_FUNCTIONAL_ACKNOWLEDGED_REJECTED' ) {
            color = '#CA443B'
          }
          return color
        }


    render() {
        let { item } = this.props;
        let response= item.summary.substring(item.summary.indexOf("Status")+8);

        console.log("response is "+ response)
        let responseCode = item.recordResponse[0].responsecode



        let resJson = "";
        let cont
        if(this.isJson(response)) {
            cont = JSON.parse(response)

            resJson = JSON.parse(response)
        }

        let respopnseJson = resJson.responses

       
        let dateReceived = item.summary.substring(item.summary.indexOf("Date")+7,item.summary.indexOf("Status")-1)
    var d = new Date(parseInt(dateReceived));

    var myTimezone = "GMT";
    var myDatetimeFormat= "MMM DD YYYY hh:mm:ss a z";
    var myDatetimeString = moment(d).tz(myTimezone).format(myDatetimeFormat);
    myDatetimeString = myDatetimeString.substring(0,myDatetimeString.indexOf("GMT"))+ "EDT"


    let releaseDate  =  myDatetimeString



        console.log(item.hasOwnProperty("errors"),"valueDetails")
        if (item.hasOwnProperty("errors") === false) {
            return (
                <div className="" style={{ marginTop: "10px" }}>
                    <div id="message-header" style={{ fontSize: "11px" }}>
                        <div>
                            CBSA
                            <span style={{ marginLeft: "70px", fontWeight: "bold" }}>
                CARGO RELEASE / ENTRY ACCOUNTING  DETAILS
              </span>

                        </div>



                        <hr />
                    </div>
                    <div id="message-body">
                        <div id="entry-acceptance-details">
                            <div style={{ fontWeight: "bold" }}>{resJson.hasOwnProperty('transaction_number')?resJson.transaction_number.toString().length>9? "CARGO RELEASE DETAILS"
                                :"ENTRY ACCOUNTING DETAILS":"ENTRY ACCOUNTING DETAILS"}
                            </div>
                           

                            <br></br>

                            <p>Status:
                        <span className={'ace-status'} style={{ color: MessageDetails.getStatusColor(item.recordResponse[0].responsecode) }}
                          ref={(p) => {
                          }}>
                          {window.shipmentCountry==='CA'?item.fromMockServer==true?"MOCK RESPONSE "+item.recordResponse[0].responsecode:item.recordResponse[0].responsecode:item.txnResponseText}
                        </span>
                      </p>

                            <div
                                style={{
                                    marginLeft: "20px",
                                    marginTop: "5px",
                                    fontWeight: "light",
                                }}
                            >
                                <br/>


                                <ul>

                                    <div
                                        style={{
                                            marginLeft: "20px",
                                            marginTop: "5px",
                                            fontWeight: "bold",
                                            textAlign: "center"
                                        }}
                                    >
                                        {responseCode.includes("RNS")||resJson.hasOwnProperty("govt_agency_id")?
                                        "RESPONSE DETAILS":
                                        null
        }
                                    </div>

                                    {responseCode.includes("RNS")||resJson.hasOwnProperty("govt_agency_id")?
                                    <br></br>
                                    :
                                    null
    }


                                    <li  style={{
                                        fontWeight: "100",
                                        fontSize:"15px"

                                    }}>
                                                                         
                                        {resJson.hasOwnProperty("current_date") ===true && responseCode==='RNS_GOODS_RELEASED'  && <span style={{  fontWeight: "100" }}>RELEASE DATE  :   </span> }{resJson.hasOwnProperty("current_date") ===true && responseCode==='RNS_GOODS_RELEASED' && <span style={{  fontWeight: "700" }}>{releaseDate}</span>}{resJson.hasOwnProperty("current_date" )&& responseCode==='RNS_GOODS_RELEASED'?<br/>:null}
                                        {resJson.hasOwnProperty("cargo_control_number") ===true  && <span style={{  fontWeight: "100" }}>CARGO CONTROL NUMBER  :   </span> }{<span style={{  fontWeight: "700" }}>{resJson.cargo_control_number}</span>}{resJson.hasOwnProperty("cargo_control_number")?<br/>:null}
                                        {resJson.hasOwnProperty("code_of_clearance") ===true  && <span style={{  fontWeight: "100" }}>PORT CODE OF CLEARNACE  :    </span> }{<span style={{  fontWeight: "700" }}>{resJson.code_of_clearance}</span>}{resJson.hasOwnProperty("code_of_clearance")?<br/>:null}
                                        {resJson.hasOwnProperty("customs_warehouse")===true  && <span style={{  fontWeight: "100" }}>CUSTOMS WAREHOUSE :  </span> }{<span style={{  fontWeight: "700" }}>{resJson.customs_warehouse}</span>}{resJson.hasOwnProperty("customs_warehouse")?<br/>:null}
                                        {resJson.hasOwnProperty("govt_agency_id")===true  && <span style={{  fontWeight: "100" }}>GOVT AGENCY ID  :  </span> }{<span style={{  fontWeight: "700" }}>{resJson.govt_agency_id}</span>} {resJson.hasOwnProperty("govt_agency_id")?<br/>:null} 
                                        {resJson.hasOwnProperty("requesting_pga")===true  && <span style={{  fontWeight: "100" }}>REQUESTING PGA:  </span> }{<span style={{  fontWeight: "700" }}>{resJson.requesting_pga}</span>} {resJson.hasOwnProperty("requesting_pga")?<br/>:null}
                                        

                                        </li>
                                </ul>

                                {resJson.hasOwnProperty("responses")?respopnseJson.toString().length!==0

                                    && (respopnseJson[0].hasOwnProperty("status_text")?respopnseJson[0].status_text !== 'ENTRY ACCEPTED': true)?
                                    <div
                                        style={{
                                            marginLeft: "20px",
                                            marginTop: "5px",
                                            fontWeight: "bold",
                                            textAlign: "center"
                                        }}
                                    >
                                        ERROR DETAILS
                                    </div>
                                    :
                                    null
                                    :
                                   null

                                }



                                {resJson.hasOwnProperty("responses")?respopnseJson.toString().length !== 0
                                    && (respopnseJson[0].hasOwnProperty("status_text")?respopnseJson[0].status_text !== 'ENTRY ACCEPTED': true)?


                                    <div style={{ height: "20px", display: "table", marginTop: "20px" }}>

                                        {resJson.responses.toString().length !== 0 ?
                                            <div style={{display: "table-cell", fontWeight: "bold"}}>
                                                Error Code
                                            </div>
                                            :
                                            null
                                        }
                                        {resJson.responses.toString().length !== 0 ?

                                            <div
                                                style={{
                                                    paddingLeft: "70px",
                                                    paddingRight: "30px",
                                                    fontWeight: "bold",
                                                    display: "table-cell",
                                                }}
                                            >
                                               <td width="20%"> ERROR MESSAGE </td> 
                                            </div>
                                            :
                                            null
                                        }

                                        {resJson.responses.toString().length !== 0
                                        && resJson.responses[0].hasOwnProperty("error_reference")
                                            ?

                                            <table
                                                style={{
                                                    paddingLeft: "150px",
                                                    paddingRight: "40px",
                                                    fontWeight: "bold",
                                                    display: "table-cell",
                                                    whiteSpace: "pre-line",


                                                }}
                                            >
                                                <tr>
                                               <th fontWeight = "bold" width="20%"> LINE ITEM </th> 
                                               </tr>
                                            </table>
                                            :
                                            null
                                        }


                                    </div>
                                    :

                                   null
                                    :
                                    null

                                }
                                {resJson.hasOwnProperty("responses")?
                                    (resJson.responses.toString().length !== 0 && respopnseJson[0].hasOwnProperty("status_text")?respopnseJson[0].status_text !== 'ENTRY ACCEPTED': true )?

                                        respopnseJson.map((iii) => (
                                            <div style={{ display: "table", fontSize: "13px" }}>
                                                <table style={{  display: "table-cell",
                                                        paddingLeft: "10px",
                                                        paddingRight: "40px",
                                                        whiteSpace: "pre-line",
                                                        width:'40px'
                                                }}>
                                                    <br/>
                                                    <tr>
                                                    {iii.hasOwnProperty("error_point")?<td>{iii.error_point}</td>:iii.hasOwnProperty("error_loc")?<td>{iii.error_loc.substring(7)}</td>:""}
                                                    </tr>

                                                    </table>
                                                <table
                                                    style={{
                                                        display: "table-cell",
                                                        paddingLeft: "40px",
                                                        paddingRight: "0px",
                                                        whiteSpace: "pre-line",
                                                        width:'500px'
                                                    }}
                                                >
                                                    <br/>
                                                    <tr>
                                                    {iii.hasOwnProperty("error_text") === true &&
                                                    (<td width="20%"> {iii.error_text }</td>)}
                                                    {iii.hasOwnProperty("status_text") === true &&
                                                    (<td width="20%" >{iii.status_text}</td>)}{" "}
                                                    </tr>
                                                </table>

                                                <table
                                                    style={{
                                                        display: "table-cell",
                                                        paddingLeft: "10px",
                                                        paddingRight: "30px",
                                                        whiteSpace: "pre-line",
                                                    }}
                                                >
                                                    <br/>

                                                    <tr>
                                                    {iii.hasOwnProperty("error_reference") === true &&
                                                    (<td width="50%" >{iii.error_reference }</td>)}
                                                    {" "}
                                                    </tr>
                                                </table>

                                            </div>
                                        ))
                                        :
                                        null

                                    :

                                    null

                                }





                                



                            </div>

                        </div>

                       



                    </div>
                </div>
            )}else{
            return (
                <div id="error" >
                    <div style={{ fontWeight: "bold",    textAlign: "center" }}>Error details</div>
                    <table style={{ fontSize: "11px" }}>
                        <tr>
                            <th style={{ fontWeight: "bold" }}>Error Code</th>
                            <th style={{ fontWeight: "bold" }}>Error Message</th>
                        </tr>
                        {item.hasOwnProperty("errors") &&
                        item.errors.map((iii, i) => (
                            <tr key={i}>
                                <td>{iii.errorCode}</td>
                                <td>{iii.errorMessage}</td>
                            </tr>
                        ))}
                    </table>
                </div>
            );
        }
    }
}

export default MessageDetails;